<template>
  <div class="fansList">
    <ul class="listBox">
      <li class="item" v-for="(item, index) in listFans" :key="index">
        <!-- logo -->
        <van-row
          type="flex"
          align="center"
          class="infoBox"
          @click="getFan(item)"
        >
          <van-col class="infoBoxLeft">
            <figure class="logo">
              <van-image
                class="logoIcon"
                :src="item.UserHeadPhoto && imgUrlFilter(item.UserHeadPhoto)"
              >
                <template v-slot:error>
                  <img
                    class="ImgIcon"
                    src="~assets/img/userManage/user_logo@2x.png"
                  />
                </template>
              </van-image>
            </figure>
          </van-col>
          <van-col class="infoBoxRigth">
            <p class="nickName">
              {{ item.NickName ? item.NickName : $t.userInterpret.noName }}
            </p>
            <p class="userName">{{ item.UserName }}</p>
            <p class="createTime">
              {{ $t.createTime }} : {{ item.CreateTime }}
            </p>
          </van-col>
          <van-col class="infoBoxOperation" v-if="isSelection">
            <van-icon name="arrow" size="20" />
          </van-col>
        </van-row>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from "vue";
import { Image, Icon } from "vant";
import { Row, Col } from "vant";
Vue.use(Row).use(Col);
Vue.use(Image);
Vue.use(Icon);

export default {
  name: "FansList",
  props: ["listFans", "isSelection"],
  components: {},
  data() {
    return {};
  },
  methods: {
    getFan(item) {
      if (this.isSelection) this.$emit("getFan", item);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin spanNowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@mixin puiblicFlex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
@mixin publicBt {
  cursor: pointer;
  -webkit-cursor: pointer;
  border-radius: 32px;
  padding: 12px 0;
  text-align: center;
}
.fansList {
  width: 100%;
  display: inline-block;
  .listBox {
    margin: 0% 3%;
    .item {
      padding: 15px;
      border-radius: 20px;
      box-shadow: 0 0 0px 1px #ece7e7;
      background-color: #ffffff;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      margin-top: 10px;
      .itemTop {
        .itemTopTitle {
          width: 77%;
          font-size: 24px;
          flex: 1;
          -webkit-flex: 1;
          color: #000000;
          font-weight: bold;
        }
        .shelves {
          border: 1px solid #999999;
          width: 110px;
          text-align: center;
          border-radius: 32px;
          padding: 12px 0;
          color: #999999;
        }
        .putaway {
          border: 1px solid #ff625c;
          width: 110px;
          text-align: center;
          border-radius: 32px;
          padding: 15px 0;
          color: #ff625c;
        }
      }
    }
  }
  .infoBox {
    .infoBoxLeft {
      width: 25%;
      text-align: center;
      line-height: 0;
      .logo {
        margin: 0;
        .logoIcon {
          .ImgIcon {
            width: 55px;
            height: 55px;
            object-fit: cover;
            border-radius: 100%;
          }
          ::v-deep .van-image__img {
            width: 55px;
            height: 55px;
            object-fit: cover;
            position: relative;
            border-radius: 100%;
          }
          ::v-deep .van-image__error {
            width: 55px;
            height: 55px;
            object-fit: cover;
            position: relative;
            border-radius: 100%;
          }
        }
      }
    }
    .infoBoxRigth {
      width: 65%;
      line-height: 3em;
      .infoBoxRigthTitle {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100%;
        margin: 0;
        padding: 0;
      }
      .nickName {
        margin: 0;
        font-size: 14px;
        color: #000;
        line-height: 1;
        margin-bottom: 15px;
        @include spanNowrap;
      }
      .userName {
        margin: 0;
        font-size: 12px;
        color: #999;
        line-height: 1;
        margin-bottom: 15px;
        @include spanNowrap;
      }
      .createTime {
        margin: 0;
        font-size: 10px;
        color: #999;
        line-height: 1;
        @include spanNowrap;
      }
    }
    .infoBoxOperation {
      width: 10%;
      color: #999999;
    }
  }
}
</style>
